var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-nav',{attrs:{"items":_vm.administrationItems,"title":_vm.menuTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }